import "./DateOfBirthInput.scss";

import cx from "classnames";
import { DatePicker } from "components/inputs";
import type { FieldErrors } from "react-hook-form";
import { calculateAge } from "utils/date-utils";

type DateOfBirthInputProps = {
  name: string;
  label?: string;
  initialDate: Date | null;
  onDateChange: (date: Date | null) => void;
  readOnly?: boolean;
  errors?: FieldErrors;
  allowFutureDates?: boolean;
  className?: string;
  isFocused?: boolean;
  isClearable?: boolean;
};

/**
 * date of birth input component that displays age as a prefix in the input
 */
const DateOfBirthInput = ({
  name,
  label = "Date of Birth",
  initialDate,
  onDateChange,
  readOnly = false,
  errors,
  allowFutureDates = false,
  className,
  isFocused,
  isClearable = false,
}: DateOfBirthInputProps) => {
  const age = calculateAge(initialDate);
  const ageText = age !== null ? `${age} years` : "";

  return (
    <DatePicker
      name={name}
      label={label}
      initialDate={initialDate}
      allowFutureDates={allowFutureDates}
      readOnly={readOnly}
      onDateChange={onDateChange}
      errors={errors}
      isFocused={isFocused}
      isClearable={isClearable}
      className={cx("date-of-birth-input", className, {
        "date-of-birth-input--has-age": ageText,
      })}
      style={
        ageText
          ? ({ "--age-prefix-text": `"${ageText}"` } as React.CSSProperties)
          : undefined
      }
    />
  );
};

export default DateOfBirthInput;
